<template>
  <div>
    <canvas id="mainChartBlu"></canvas>
  </div>
</template>
<script>
import Chart from "chart.js";
import { mapGetters } from "vuex";

export default {
  props: ["fundTailsArchive"],
  created() {
    this.setArraysChart();
    this.setChartMode("latest");
  },
  mounted() {},
  data: () => ({
    chart: "",
    selectedChart: "",
    fundTails: "??",
    allPeriod: false,
    lastFiveDays: false,

    assetsPrices: [],
    assetsLabels: [],
    chartData: {
      labels: [],
      prices: []
    }
  }),
  components: {},
  methods: {
    setChartMode(period) {
      let labels = this.assetsLabels;
      let prices = this.assetsPrices;

      this.allPeriod = false;
      this.lastFiveDays = true;
      this.chartData.labels = labels.slice(Math.max(labels.length - 6, 1));
      this.chartData.prices = prices.slice(Math.max(prices.length - 6, 1));

      this.setUpChart("2");
    },

    setArraysChart() {
      let archives = this.fundTailsArchive.data;
      let self = this;
      let today = new Date();
      let todayMonth = today.getMonth() + 1;

      if (todayMonth < 10) {
        todayMonth = "0" + todayMonth;
      }

      archives.sort(function(a, b) {
        let dataA = new Date(a.createdAt);
        let dataB = new Date(b.createdAt);
        return dataA - dataB;
      });

      for (let i = 0; i < archives.length; i++) {
        if (
          archives[i].tokenPrice &&
          archives[i].createdAt &&
          self.checkDate(archives[i])
        ) {
          self.assetsPrices.push(archives[i].tokenPrice.toFixed(2));
          let date = new Date(archives[i].createdAt);
          self.assetsLabels.push(
            date.getDate() +
              " / " +
              (date.getMonth() + 1) +
              " / " +
              date.getFullYear()
          );
        }
      }

      this.assetsLabels.push(
        today.getDate() + " / " + todayMonth + " / " + today.getFullYear()
      );
      this.assetsPrices.push(this.bluValue[0].value.toFixed(2));
    },

    checkDate(date) {
      let startLimit = "2019-04-11T10:35:13.000Z";
      if (date.createdAt > startLimit) {
        return true;
      }
    },

    setUpChart(dataSet) {
      this.selectedChart = dataSet;

      let chartData2 = {
        type: "line",
        data: {
          labels: this.chartData.labels,
          datasets: [
            {
              label: "BLU (TUSD)",
              data: this.chartData.prices,
              backgroundColor: ["#424b7d"],
              borderColor: ["#424b7d"],
              fill: false,
              borderWidth: 2,
              lineTension: 0
            }
          ]
        },
        options: {
          tooltips: {
            enabled: true,
            colors: "red",
            caretSize: 10,
            fill: true,
            displayColors: false,
            mode: "nearest"
          },

          legend: {
            display: false
          },

          elements: {
            point: {
              pointStyle: "circle",
              radius: 4
            }
          },

          scales: {
            xAxes: [
              {
                display: true
              }
            ],
            yAxes: [
              {
                ticks: {
                  beginAtZero: true,
                  min: 30,
                  stepSize: 10,
                  callback: function(value) {
                    return value + " (TUSD)";
                  }
                }
              }
            ]
          }
        }
      };
      if (dataSet == "2") {
        this.createChart("mainChartBlu", chartData2);
      }
    },
    createChart(chartId, chartData) {
      setTimeout(() => {
        const ctx = document.getElementById(chartId);
        const nasChart = new Chart(ctx, {
          type: chartData.type,
          data: chartData.data,
          options: chartData.options
        });
      }, 100);
    }
  },
  computed: {
    ...mapGetters(["currencies", "bluValue"])
  },
  watch: {}
};
</script>



// WEBPACK FOOTER //
// src/components/public/charts_component/ChartLineLatest.vue